import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { Clip } from '@ff-os/rendering-shared/Clip';
import { Spaces } from '@ff-os/rendering-shared/coordinates';
import { PaintTarget } from '@ff-os/rendering-shared/targets';
import { selectVariablePaintables } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { Paintable } from 'ff-canvas';
import { selectMetaViewbox } from '../../../_redux-meta';
import { selectBackgroundPaintableByVariantId, selectVariantPreviewClip } from '../../../_redux-variants';
import { Preview2d } from '../../../preview/Preview2d';

const _GiftWindowPreview2d = ({ paintables, spaces, previewClip }: Props) => (
    <Preview2d paintables={paintables} spaces={spaces} previewClip={previewClip} />
);

type Props = {
    paintables: Paintable[];
    spaces: Spaces;
    previewClip: Clip | undefined;
};

const mapStateToProps = (state: GiftPdpState) => ({
    paintables: selectPaintablesForPreview2d(state, 'mockup'),
    previewClip: selectVariantPreviewClip(state)
});

export const GiftWindowPreview2d = connect(
    mapStateToProps
)(_GiftWindowPreview2d);

const selectPaintablesForPreview2d = createSelector([
    (state: GiftPdpState, paintTarget: PaintTarget) => selectVariablePaintables(state, paintTarget),
    state => selectPreviewBackgroundPaintableForPreview2d(state)
], (paintables: Paintable[], background: Paintable) => paintables.concat(background));

const selectPreviewBackgroundPaintableForPreview2d = createSelector([
    state => state,
    selectMetaViewbox
], selectBackgroundPaintableByVariantId);